import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { Authenticated, Unauthenticated } from 'convex/react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

const AuthRoute = () => {
  return (
    <>
      {/* Redirect authenticated users to dashboard */}
      <Authenticated>
        <Navigate to='/dashboard' replace />
      </Authenticated>
      {/* Show auth pages for unauthenticated users */}
      <Unauthenticated>
        <LazyWrapper>
          <Outlet />
        </LazyWrapper>
      </Unauthenticated>
    </>
  );
};

export const Route = createFileRoute('/auth')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['auth']);
    return null;
  },
  component: AuthRoute,
});
